module.exports = __webpack_public_path__ + "static/media/7@720w.ed74ead7.jpg";